<template>
    <div class="col-md-10 col-lg-10 offset-md-1 offset-lg-1 page">
        <div class="header2">
            <h1 class="title">
                CPT Billing
            </h1>
        </div>
        <Accordion :multiple="true">
            <template v-for="patient in patientList">
                <AccordionTab v-if="cptData && patient.externId in cptData" :header="patient.firstName + ' ' + patient.lastName">
                    <Accordion :multiple="true">
                        <AccordionTab v-for="(meter,cptCode) in cptData[patient.externId].cptList" :header="cptCode">
                            <Accordion :multiple="true">
                                <AccordionTab v-for="(metaData, meter) in cptData[patient.externId].current[cptCode]" :header="'Device ' + meter">
                                    <div class="data">
                                        <div v-if="!Array.isArray(cptData[patient.externId].historical)" v-for="val in getHistorical(patient.externId, cptCode, meter)" class="datarow">
                                            <span class="dates">{{ val.firstDate + " - " + val.lastDate}}</span>
                                            <span class="billStatus">{{ {0:"Not Billable", 1:"Billable", 2:"Billed"}[val.status]}}</span>
                                        </div>
                                        <div v-if="metaData.firstDate && metaData.lastDate" class="datarow">
                                            <!-- <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row"> -->
                                            <span class="dates">{{ metaData.firstDate + " - " + metaData.lastDate }}</span>
                                            <span class="billStatus">{{ {0:"Not Billable", 1:"Billable", 2:"Billed"}[metaData.status] }}</span>
                                            <!-- </div> -->
                                        </div>
                                        <div v-else class="datarow">
                                            <span class="nodata">No data transmitted yet</span>
                                        </div>
                                    </div>
                                </AccordionTab>
                            </Accordion>
                        </AccordionTab>
                    </Accordion>
                </AccordionTab>
            </template>
        </Accordion>
        <!-- <div class="p-accordion p-component">
            <accordion class="p-accordion-tab">
                <accordion-tab v-for="(patient,index) in patientList" :header="patient.externId" :key="index" class="p-accordion-header">
                    TESTING
                </accordion-tab>
            </accordion>
        </div> -->
    </div>
</template>

<script>
import { CURR_API, OTHER_API } from '@/constants/apis'
import axios from 'axios'
import { mapGetters } from "vuex";

export default {
    name: "CptBilling",
    data() {
        return {
            cptData: null,
        }
    },
    computed: {
        ...mapGetters("login", {
            allData: "getAllData"
        }),
        patientList: function() {
            return this.allData.patient.relations[0].value
        }
    },
    async mounted() {
        this.getPatientCpts()
    },
    methods: {
        async getPatientCpts() {
            let content = {
                "PatientCpt": {
                    "API_Meth": "GetPatientCptBilling",
                    "pids": this.patientList.map(patient => patient.externId)
                }
            }
            await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
                .then((res) => {
                    if (!Array.isArray(res.data)){
                        this.cptData = Object.fromEntries(Object.entries(res.data).filter(([key, value]) => !Array.isArray(value.current)))
                        console.log(this.cptData)
                    }
                }, error => {
                    alert("Error: Check the console log")
                    console.log(error)
                })
        },
        getHistorical(externId, cptCode, meter){
            let historical = this.cptData[externId].historical
            if (historical[cptCode] && historical[cptCode][meter])
                return historical[cptCode][meter]
            return {}
        }
    }
}
</script>

<style scoped lang="scss">
.header2 {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 20px;
    //   color: #0060ff;
}
.billStatus {
    float: right;
}
.data {
    display: flex;
    flex-direction: column-reverse;
}
</style>